import React from "react";
import { Helmet } from "react-helmet";
import { helmetJsonLdProp } from "react-schemaorg";

const AdditionalMetaData = () => {
  return (
    <Helmet
      script={[
        helmetJsonLdProp({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          name: "Xometry",
          slogan: "Where Big Ideas are Built",
          legalName: "Xometry, Inc.",
          email: "support@xometry.com",
          description:
            "Xometry's (NASDAQ: XMTR) AI-powered marketplace, popular Thomasnet industrial sourcing platform and suite of cloud-based services are rapidly digitizing the $2.4 trillion manufacturing industry. Xometry provides manufacturers the critical resources they need to grow their business and makes it easy for buyers to access global manufacturing capacity and create locally resilient supply chains. The Xometry Instant Quoting Engine® leverages millions of pieces of data to quickly and effectively analyze complex parts in real-time, match buyers with the right suppliers globally and provide accurate pricing and lead times. Through its extensible marketplace, Xometry continuously scales its offerings, delivering an ever-expanding menu of manufacturing capabilities. Learn more at www.xometry.com or follow @xometry.",
          founder: {
            "@type": "Person",
            name: "Randy Altschuler",
            birthDate: "December 8, 1970",
            email: "randy@xometry.com",
            givenName: "Randolph",
            jobTitle: "CEO",
            nationality: "American",
            sameAs: [
              "https://en.wikipedia.org/wiki/Randy_Altschuler",
              "https://twitter.com/randy_alt",
              "https://councils.forbes.com/profile/Randy-Altschuler-CEO-Co-Founder-Xometry/89efcb3f-515b-4cea-84c8-226b1eb9f04a",
            ],
          },
          address: {
            "@type": "PostalAddress",
            addressCountry: "ISO ",
            addressLocality: "US",
            postalCode: "20852",
            streetAddress: "6116 Executive Blvd, Ste. 800, North Bethesda, MD",
          },
          contactPoint: {
            "@type": "ContactPoint",
            telephone: "+1-800-983-1959",
            contactType: "technical support",
            contactOption: "TollFree",
            areaServed: "US",
            availableLanguage: ["English"],
          },
          url: "https://www.xometry.com",
          logo: {
            "@type": "ImageObject",
            inLanguage: "en-US",
            url: "https://www.xometry.com/xometry-logo-condensed.svg",
            contentUrl: "https://www.xometry.com/xometry-logo-condensed.svg",
            caption: "Xometry, Where Big Ideas are Built",
          },
          sameAs: [
            "https://www.facebook.com/xometry/",
            "https://www.linkedin.com/company/xometry",
            "https://www.youtube.com/@XometryHQ",
            "https://www.pinterest.com/xometry/",
            "https://twitter.com/Xometry",
          ],
          member: {
            "@type": "OrganizationRole",
            member: {
              "@type": "Person",
              name: "Randy Altschuler",
              sameAs: [
                "https://en.wikipedia.org/wiki/Randy_Altschuler",
                "https://twitter.com/randy_alt",
                "https://councils.forbes.com/profile/Randy-Altschuler-CEO-Co-Founder-Xometry/89efcb3f-515b-4cea-84c8-226b1eb9f04a",
              ],
            },
          },
          award: "Award Name",
          certifications: [
            "ITAR-registered",
            "ISO 9001:2015",
            "ISO 13485:2016",
            "AS9100D",
          ],
          geo: {
            "@type": "GeoCoordinates",
            latitude: "39.0478297",
            longitude: "-77.1259975",
          },
          subOrganization: [
            {
              "@type": "Organization",
              name: "Thomas",
              description:
                "We Power the Growth of North American Manufacturing. For over 125+ years, Thomas has served as North America’s number one industrial sourcing platform and marketing powerhouse. We serve professionals on both sides of the industrial buying process to create solutions that inform, support, and empower industry.",
              url: "https://www.thomasnet.com",
              logo: {
                "@type": "ImageObject",
                url: "https://cdn40.thomasnet.com/img40/thomas-logo-blue-x.svg",
              },
              contactPoint: {
                "@type": "ContactPoint",
                url: "https://help.thomasnet.com/kb-tickets/new",
                telephone: "+1-212-629-2149",
              },
              sameAs: [
                "https://www.facebook.com/ThomasForIndustry/",
                "https://www.linkedin.com/company/thomasforindustry",
                "https://twitter.com/Thomasnet",
                "https://www.crunchbase.com/organization/thomasnet",
              ],
            },
            {
              "@type": "Organization",
              name: "Xometry Pro",
              description:
                "Xometry Pro is a media platform for engineers, product designers, and tech enthusiasts that offers a large knowledge base as well as a community. It is created and moderated by Xometry, an AI-powered platform for sourcing custom manufacturing.",
              url: "https://xometry.pro/",
              logo: {
                "@type": "ImageObject",
                url: "https://xometry.pro/wp-content/uploads/2024/01/xometry-pro-logo.svg",
              },
              contactPoint: {
                "@type": "ContactPoint",
                url: "https://xometry.pro/en/about/",
                telephone: "+49-89-3803-4818",
              },
              sameAs: [
                "https://www.facebook.com/people/Xometry-Pro-Knowledge-Community-For-Engineers-Product-Designers/61556517008142/",
                "https://www.linkedin.com/showcase/xometry-pro/",
              ],
            },
            {
              "@type": "Organization",
              name: "Xometry Türkiye",
              description:
                "Xometry's (NASDAQ: XMTR) AI-powered marketplace and suite of cloud-based services are rapidly digitising the manufacturing industry. Xometry provides manufacturers with the critical resources they need to grow their business and makes it easy for buyers to access global manufacturing capacity and create resilient supply chains.",
              url: "https://xometry.com.tr/",
              logo: {
                "@type": "ImageObject",
                url: "https://xometry.eu/wp-content/uploads/2021/12/Logomark_Xometry_Blue-1.svg",
              },
              contactPoint: {
                "@type": "ContactPoint",
                url: "https://xometry.com.tr/tr/iletisim/",
                telephone: "+90-(212)-221-0635",
              },
              sameAs: [
                "https://www.facebook.com/xometryturkiye",
                "https://www.linkedin.com/company/xometry-turkiye/",
                "https://twitter.com/XometryTR",
                "https://www.instagram.com/xometryturkiye/",
                "https://www.youtube.com/@Xometry-Turkiye",
              ],
            },
            {
              "@type": "Organization",
              name: "Xometry UK",
              description:
                "Xometry's (NASDAQ: XMTR) AI-powered marketplace and suite of cloud-based services are rapidly digitising the manufacturing industry. Xometry provides manufacturers with the critical resources they need to grow their business and makes it easy for buyers to access global manufacturing capacity and create resilient supply chains.",
              url: "https://xometry.uk/",
              logo: {
                "@type": "ImageObject",
                url: "https://xometry.eu/wp-content/uploads/2021/12/Logomark_Xometry_Blue-1.svg",
              },
              contactPoint: {
                "@type": "ContactPoint",
                url: "https://xometry.uk/contacts/",
                telephone: "+44-1245-840035",
              },
              sameAs: [
                "https://www.facebook.com/xometryeurope",
                "https://www.linkedin.com/company/xometry-uk/",
                "https://twitter.com/XometryEU",
                "https://www.instagram.com/xometryeurope/",
                "https://www.youtube.com/channel/UCJ3IcspDxv3WTNu7BgPcnRw",
              ],
            },
            {
              "@type": "Organization",
              name: "Xometry Europe",
              description:
                "Xometry's (NASDAQ: XMTR) AI-powered marketplace and suite of cloud-based services are rapidly digitising the manufacturing industry. Xometry provides manufacturers with the critical resources they need to grow their business and makes it easy for buyers to access global manufacturing capacity and create resilient supply chains.",
              url: "https://xometry.eu/",
              logo: {
                "@type": "ImageObject",
                url: "https://xometry.eu/wp-content/uploads/2021/12/Logomark_Xometry_Blue-1.svg",
              },
              contactPoint: {
                "@type": "ContactPoint",
                url: "https://xometry.eu/en/contacts/",
                telephone: "+49-89-3803-4818",
              },
              sameAs: [
                "https://www.facebook.com/xometryeurope",
                "https://www.linkedin.com/company/xometry-europe/",
                "https://twitter.com/XometryEU",
                "https://www.instagram.com/xometryeurope/",
                "https://www.youtube.com/channel/UCJ3IcspDxv3WTNu7BgPcnRw",
              ],
            },
          ],
        }),
      ]}
    />
  );
};

export default AdditionalMetaData;
